import { useLanguage } from "@/LanguageContext";
import { motion } from "framer-motion";

const MONIQUE_VIDEO =
  "https://customer-assets.emergentagent.com/job_senior-care-valais/artifacts/nf2bdrj5_ScreenRecording_04-16-2026%2018-05-13_1.mov";

const videoCaption = {
  fr: {
    name: "Monique",
    location: "Crans-Montana",
    caption: "Monique témoigne de son expérience avec Giada et Présence & Sourire.",
  },
  de: {
    name: "Monique",
    location: "Crans-Montana",
    caption: "Monique berichtet über ihre Erfahrung mit Giada und Présence & Sourire.",
  },
  en: {
    name: "Monique",
    location: "Crans-Montana",
    caption: "Monique shares her experience with Giada and Présence & Sourire.",
  },
};

const sectionTitle = {
  fr: { label: "Témoignages", title: "Ce que disent nos familles" },
  de: { label: "Erfahrungen", title: "Was unsere Familien sagen" },
  en: { label: "Testimonials", title: "What our families say" },
};

export default function TestimonialsSection() {
  const { language } = useLanguage();
  const vidText = videoCaption[language] || videoCaption.fr;
  const titles = sectionTitle[language] || sectionTitle.fr;

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 lg:py-32 bg-[#F0EBE3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-sm font-body uppercase tracking-[0.2em] text-[#6FA8B6] mb-4">
            {titles.label}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2C3E50]">
            {titles.title}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mx-auto"
          data-testid="video-testimonial"
        >
          <div className="bg-[#F7F3EE] rounded-3xl overflow-hidden shadow-sm border border-[#D4CABC]/50">
            <div className="aspect-[9/16] sm:aspect-video max-h-[500px] w-full bg-[#2C3E50] relative">
              <video
                controls
                playsInline
                preload="metadata"
                className="w-full h-full object-contain bg-black"
                data-testid="monique-video"
              >
                <source src={MONIQUE_VIDEO} type="video/quicktime" />
                <source src={MONIQUE_VIDEO} type="video/mp4" />
              </video>
            </div>
            <div className="p-6 sm:p-8 text-center">
              <p className="font-heading text-xl text-[#2C3E50] mb-1">
                {vidText.name}
              </p>
              <p className="font-body text-sm text-[#6FA8B6] mb-3">
                {vidText.location}
              </p>
              <p className="font-body text-sm text-[#2C3E50]/60 leading-relaxed">
                {vidText.caption}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
